"use strict";
// NOTE: This code was generated and should not be changed
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMarketingResourceComponentView = void 0;
/**
 * A builder for MarketingResourceComponentView
 *
 * @param data - The event data
 * @return The formatted event data for MarketingResourceComponentViewEvent
 */
function createMarketingResourceComponentView(data) {
    return {
        name: 'MarketingResourceComponentView',
        environments: ['browser'],
        data: data,
    };
}
exports.createMarketingResourceComponentView = createMarketingResourceComponentView;
//# sourceMappingURL=createMarketingResourceComponentView.js.map